import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Bot } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function AIMarketing() {
  usePageMeta({
    title: "קידום באמצעות AI: טכנולוגיה מתקדמת שחוסכת לכם זמן וכסף | upsite",
    description: "העתיד כבר כאן. נצלו את כוחה של הבינה המלאכותית לאופטימיזציית תוכן ודירוגים מהירים ומדויקים מאי פעם. גלו איך אפסייט רותמים את ה-AI להצלחת העסק שלכם",
  });

  return (
    <ServicePageTemplate
      icon={Bot}
      title="קידום באמצעות AI"
      subtitle="שיווק AI"
      description="שימוש בכלי AI מתקדמים לייעול תהליכי שיווק וצמיחה. אנחנו משלבים טכנולוגיה חדשנית עם ניסיון שיווקי עמוק כדי להאיץ את הצמיחה שלכם."
      image="/images/services/ai-marketing.jpeg"
      benefits={[
        "ייעול תהליכי שיווק באמצעות כלי AI",
        "יצירת תוכן אוטומטית ואיכותית",
        "ניתוח נתונים מתקדם לקבלת החלטות חכמות",
        "אוטומציה של תהליכי עבודה שיווקיים",
        "זיהוי הזדמנויות צמיחה באמצעות AI",
        "שילוב AI באסטרטגיית השיווק הכוללת",
      ]}
      processSteps={[
        { title: "אבחון ומיפוי", desc: "זיהוי תהליכים שניתן לייעל באמצעות AI ומיפוי הזדמנויות." },
        { title: "בחירת כלים", desc: "בחירת כלי ה-AI המתאימים ביותר לצרכים שלכם." },
        { title: "הטמעה ואינטגרציה", desc: "הטמעת הכלים בתהליכי העבודה הקיימים." },
        { title: "אופטימיזציה", desc: "מדידת תוצאות, כיוונון ושיפור מתמיד." },
      ]}
    />
  );
}
